/*
 * Copyright © 2023 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {
    Component,
    ContentChildren,
    InjectionToken,
    Input,
    QueryList,
    ViewEncapsulation
} from '@angular/core';
import { FcAccordionItemComponent } from './fc-accordion-item/fc-accordion-item.component';

export const FC_ACCORDION = new InjectionToken<FcAccordionComponent>('FcAccordionComponent');

/**
 * Fc accordion component.
 */
@Component({
    selector: 'fc-accordion',
    templateUrl: './fc-accordion.component.html',
    styleUrls: ['./fc-accordion.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{provide: FC_ACCORDION, useExisting: FcAccordionComponent}]
})
export class FcAccordionComponent {

    /**
     * FcAccordionItemComponent query list.
     */
    @ContentChildren(FcAccordionItemComponent) accordionItems!: QueryList<FcAccordionItemComponent>;

    /**
     * Whether the accordion should allow multiple expanded accordion items simultaneously.
     */
    @Input() multi: boolean = false;

    /**
     * Closes all enabled accordion items.
     */
    closeAll() {
        this.accordionItems.forEach((accordionItem: FcAccordionItemComponent) => {
            accordionItem.expanded = false;
        });
    }

    /**
     * Opens all enabled accordion items in an accordion where multi is enabled.
     */
    openAll() {
        if (this.multi) {
            this.accordionItems.forEach((accordionItem: FcAccordionItemComponent) => {
                if (!accordionItem.disabled) {
                    accordionItem.expanded = true;
                }
            });
        }
    }

    /**
     * Opens first accordion item only.
     */
    openFirstItem() {
        this.accordionItems.forEach((accordionItem: FcAccordionItemComponent, i: number) => {
            if (!accordionItem.disabled) {
                if (this.multi) {
                    accordionItem.expanded = i === 0  ? true : accordionItem.expanded;
                } else {
                    accordionItem.expanded = i === 0;
                }
            }
        });
    }

}
